import { View, Text } from "@src/components";
import { useUnistyles } from "react-native-unistyles";
import { FC, memo } from "react";

interface DayColumnHeaderProps {
  dayName: string;
  dateString: string;
  isToday: boolean;
  isPastDay: boolean;
}

export const DayColumnHeader: FC<DayColumnHeaderProps> = memo(({ dayName, dateString, isToday, isPastDay }) => {
  const { theme } = useUnistyles();

  return (
    <View
      alignItems="center"
      justifyContent="center"
      marginBottom="xl"
      style={{ marginTop: -8, opacity: isPastDay ? 0.5 : 1 }}
    >
      <Text
        textStyle={isToday ? "xs/bold" : "xs/regular"}
        color="text"
        textAlign="center"
        style={{
          marginBottom: 6,
          ...(isToday && { color: theme.colors.interactive.buttons.default_background }),
        }}
      >
        {dayName}
      </Text>
      <View alignItems="center" justifyContent="center" style={{ position: "relative" }}>
        {isToday && (
          <View
            style={{
              position: "absolute",
              width: 32,
              height: 32,
              borderRadius: 6,
              backgroundColor: theme.colors.interactive.buttons.default_background,
            }}
          />
        )}
        <Text
          textStyle="md/semibold"
          color="text"
          textAlign="center"
          style={{
            zIndex: 1,
            ...(isToday && { color: theme.colors.white.default }),
          }}
        >
          {dateString}
        </Text>
      </View>
    </View>
  );
});
